import { PlatformEnum } from "@/types/modular-permissions.types";
import { BsInstagram, BsTelegram, BsTwitterX } from "react-icons/bs";

export const resolvePlatformLogo = (platform: PlatformEnum | undefined) => {
  if (!platform) return undefined;

  switch (platform) {
    case PlatformEnum.Telegram:
      return BsTelegram;
    case PlatformEnum.Twitter:
      return BsTwitterX;
    case PlatformEnum.Instagram:
      return BsInstagram;
  }
};
